module.exports = __webpack_public_path__ + "img/violenceSampleCalculator.cda2ab0a.svg";